export const dateFormat = "DD.MM.YYYY";
export const timeFormat = "HH:mm";
export const longTimeFormat = "HH:mm:ss";
